export enum BodyParameters {
  FT = 'ft',
  CM = 'cm',
}

export enum WeightParameters {
  LBS = 'lbs',
  KG = 'kg',
}
